import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ChatBot from "./components/ChatBot";
import "./i18n";
import "./App.css";

// Pages
import HomePage from "./pages/HomePage";
import LandingPage from "./pages/LandingPage";
import ParkingInfoPage from "./pages/ParkingInfoPage";
import { parkingPages } from "./components/ParkingContent";
import BookingPage from "./pages/BookingPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AccountPage from "./pages/AccountPage";
import WorkerDashboard from "./pages/WorkerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SurveyPage from "./pages/SurveyPage";
import ReservationPrint from "./pages/ReservationPrint";

// Wrapper to hide chatbot on print/admin pages
const ChatBotWrapper = () => {
  const location = useLocation();
  if (location.pathname.includes('/print') || location.pathname.includes('/admin')) {
    return null;
  }
  return <ChatBot />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          {parkingPages.map(page => <Route key={page.slug} path={`/${page.slug}`} element={<ParkingInfoPage page={page} />} />)}
          <Route path="/reservar" element={<BookingPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/terminos" element={<TermsPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/survey/:token" element={<SurveyPage />} />
          <Route path="/reserva/:code/print" element={<ReservationPrint />} />
          
          {/* Auth routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/registro" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          
          {/* Customer routes */}
          <Route path="/account" element={<AccountPage />} />
          
          {/* Worker routes */}
          <Route path="/worker/login" element={<LoginPage />} />
          <Route path="/worker" element={<WorkerDashboard />} />
          
          {/* Admin routes */}
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/reservas" element={<AdminDashboard />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
        <Toaster position="top-center" richColors />
        <ChatBotWrapper />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
